import { render, staticRenderFns } from "./DashboardOverviewView.vue?vue&type=template&id=43e79adf&scoped=true&"
import script from "./DashboardOverviewView.vue?vue&type=script&lang=js&"
export * from "./DashboardOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverviewView.vue?vue&type=style&index=0&id=43e79adf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e79adf",
  null
  
)

/* custom blocks */
import block0 from "./DashboardOverviewView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports